<div class="lvi-content list-view-item-hover py-3">
    <div *ngIf="data.type == MessageAdminType.INFORMATION" class="avatar">
        <i class="material-icons-outlined">info</i>
    </div>
    <div *ngIf="data.type == MessageAdminType.CONFIRMATION" class="avatar success">
        <i  class="material-icons-outlined">check</i>
    </div>
    <div *ngIf="data.type == MessageAdminType.AVERTISSEMENT" class="avatar warning">
        <i  class="material-icons-outlined">warning</i>
    </div>
    <div *ngIf="data.type == MessageAdminType.ALERTE" class="avatar danger">
        <i  class="material-icons-outlined">warning</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="extraOptions.onSelect(data)">{{ data.objet }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.bibliotheque.notifications.accueil.role'"></strong>
                <span>{{ data.nbRoles }}</span>
            </li>
            <li *ngIf="data.dateDebut">
                <strong [translate]="'admin.bibliotheque.notifications.accueil.dateDebut'"></strong>
                <span>{{ data.dateDebut | date:'shortDate' }}</span>
            </li>
            <li *ngIf="data.dateFin">
                <strong [translate]="'admin.bibliotheque.notifications.accueil.dateFin'"></strong>
                <span>{{ data.dateFin | date:'shortDate' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.bibliotheque.notifications.accueil.affiche'"></strong>
                <span translate>{{ isAffiche ? 'global.oui' : 'global.non' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.bibliotheque.notifications.accueil.actif'"></strong>
                <span translate>{{ data.actif ? 'global.oui' : 'global.non' }}</span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button (click)="onDelete()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>
